export default () => ({
  comments: null,
  rating: {
    positive: 0,
    negative: 0
  }
})
